import axios from 'axios'
import * as accessTokenInfo from "../../accessToken";
import router from '../../../router'

export const fetchCampaignList = ({commit, dispatch}, payload) => {
    
    commit('toggleLoadingState', true)
    if(payload.store_list.length === 0) {
        return false
    } else {
        axios.post('/campaign/index.php', payload, accessTokenInfo.accessTokenInfo())
        .then(res => {

            if(res.data.try_again) {
                dispatch('fetchCampaignList', payload)
            } else {
                commit('setCampaignList', {response: res.data.response, total: res.data.total, page_number: res.data.page_number, page_number: res.data.page_number})                 
            }
        })
        .catch(error => {
            commit('displayMessageAlert', {message: error, type: 'Error'})
        })
        .finally( () => {
            commit('toggleLoadingState', false)
        })
    }
}

export const fetchCampaignCustomerAnalysisList = ({commit}, payload) => {
    
    commit('toggleLoadingState', true)
    axios.post('/campaign/customerAnalysis.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        commit('setCampaignCustomerList', res.data.response)
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })

}

export const fetchCampaignData = ({commit}, payload) => {
    commit('toggleLoadingState', true)
    axios.post('/campaign/single.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
                
        if(res.data.status) {
            
            commit('setCampaignData', {response: res.data.response, copy: payload.copy})   
            
            if(payload.navigate) {
                router.push(router.currentRoute.fullPath+'/form/')
            }

        } else {
            commit('resetCampaignData')
        }

    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const submitCampaignData = ({commit, dispatch}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/campaign/save.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {    
            
        if(res.data.status) {
            commit('displaySuccessNotification', {message: 'Data submitted successfully!!!'});
            if(payload.id === 0) {
                router.push(router.currentRoute.fullPath.replace('/form/', ''))
            } else {
                dispatch('fetchCampaignData', {id: res.data.id})
            }            
        } else {
            commit('displayMessageAlert', {message: res.data.message, type: 'Error', displayHTML: true});            
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const deleteCampaignData = ({commit, dispatch}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/campaign/delete.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        if(res.data.status) {
            commit('displaySuccessNotification', {message: 'Data deleted successfully!!!'});
            dispatch('fetchCampaignList', payload.list_query)
        } else {
            commit('displayMessageAlert', {message: res.data.message, type: 'Error', displayHTML: true});
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}


// WEBPACK FOOTER //
// ./src/store/modules/campaign/actions.js